import { formatDate, formatPhone } from '@ui/src';
import {
  ApplicationType,
  NewApplicationListItem,
  NewApplicationStatus,
  ReviewStatus,
} from '../../types';
import getApplicationStatus from '../../helpers/get-status-name';

import cn from '../styles.module.css';

const formatNewApplicationsList = (
  list: NewApplicationListItem[],
): NewApplicationListItem[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    let statusClassName = '';
    let reviewStatus = '';
    let type = '';

    if (result.status === NewApplicationStatus.ACCEPTED) {
      statusClassName = cn.newApplicationStatusAccepted;
    } else if (result.status === NewApplicationStatus.INCOMPLETE) {
      statusClassName = cn.newApplicationStatusIncomplete;
    } else if (result.status === NewApplicationStatus.DECLINED) {
      statusClassName = cn.newApplicationStatusDeclined;
    }

    if (result.type === ApplicationType.INDIVIDUAL) {
      type = 'Individual';
    } else if (result.type === ApplicationType.CORPORATE) {
      type = 'Corporate';
    } else if (result.type === ApplicationType.COMPANY_OFFICIAL) {
      type = 'Company official';
    }

    if (result.reviewStatus === ReviewStatus.NONE) {
      reviewStatus = 'None';
    } else if (result.reviewStatus === ReviewStatus.ACCEPTED) {
      reviewStatus = 'Accepted';
    } else if (result.reviewStatus === ReviewStatus.HAS_DUPLICATE) {
      statusClassName = cn.newApplicationStatusDeclined;
      reviewStatus = 'Has Duplicate';
    } else if (result.reviewStatus === ReviewStatus.REJECTED) {
      reviewStatus = 'Rejected';
    }

    const render: Record<string, React.JSX.Element> = {
      id: <div className={cn.applicationDocId}>{result.id}</div>,
      createdAt: <div>{formatDate(result.createdAt)}</div>,
      phone: <div>{formatPhone(result.phone) || '-'}</div>,
      firstName: (
        <div>
          {result.type === ApplicationType.INDIVIDUAL ||
          result.type === ApplicationType.COMPANY_OFFICIAL
            ? result.firstName || '-'
            : '-'}
        </div>
      ),
      lastName: (
        <div>
          {result.type === ApplicationType.INDIVIDUAL ||
          result.type === ApplicationType.COMPANY_OFFICIAL
            ? result.lastName || '-'
            : '-'}
        </div>
      ),
      companyName: (
        <div>
          {result.type === ApplicationType.CORPORATE
            ? `${result.companyName}`
            : '-'}
        </div>
      ),
      countryId: (
        <div className={cn.applicationCountry}>
          {result.country ? result.country.name : '-'}
        </div>
      ),
      reviewEmployeeId: (
        <div>
          {result.reviewEmployeeId
            ? `${result?.reviewEmployee?.profile?.firstName} ${result?.reviewEmployee?.profile?.lastName}`
            : '-'}
        </div>
      ),
      status: (
        <div
          className={`${statusClassName} ${cn.newApplicationStatus} ${cn.applicationStatus}`}
        >
          {`${getApplicationStatus(result.status)} ${
            result.reviewStatus === ReviewStatus.HAS_DUPLICATE
              ? `(${reviewStatus})`
              : ''
          }`}
        </div>
      ),
      email: (
        <div className={cn.newApplicationEmail}>{result.email || '-'}</div>
      ),
      type: <div className={cn.newApplicationType}>{type}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatNewApplicationsList;
